import http from '@/utils/http-common'
import axios from 'axios'
import Swal from 'sweetalert2'
import router from '@/router'
import store from '@/store'
import { getRefreshTokenConfig } from '@/utils/auth-tokens'

function methodRecall() { // main.js, mutations.js, actions.js, index.js(router) 공유
  return new Promise((resolve, reject) => {
    // BE에 access token 저장 후 Promise 객체 return (이전 method 재호출을 위해)
    if (!store.state.isMethodRecalling) {
      // methodRecall이 호출되고 새로운 token을 갱신 및 저장 중인 상태가 아니라면
      console.log("setIsMethodRecalling true");
      store.commit('setIsMethodRecalling', true); // isMethodRecalling을 true로 변경(새로운 token을 갱신 및 저장 중인 상태)
      console.log('refresh_token', store.state.refresh_token)
      if (store.state.user_info.user_type === 'google') {
        axios
        .post('https://oauth2.googleapis.com/token', {
          // refresh token으로 새로운 access token 갱신
          client_id: process.env.VUE_APP_CLIENT_ID,
          client_secret: process.env.VUE_APP_CLIENT_SECRET,
          refresh_token: store.state.refresh_token,
          grant_type: 'refresh_token',
        })
        .then((res) => {
          // refresh_token이 만료되기 전이므로 정상적으로 access_token을 갱신
          console.log('refresh_token이 만료되기 전이므로 정상적으로 access_token을 갱신');
          console.log(res);
          http
          .get('account/update-token/', { headers: { Authorization: 'Bearer ' + res.data.access_token } }) // BE에 새로 갱신한 access token 정보 저장
          .then((res1) => {
            console.log(res1);
            console.log('BE에 새로 갱신한 access token 정보 저장');
            store.commit('setAccessToken', res.data.access_token); // store에 새로 갱신한 access token 저장
            store.commit('setIdToken', res.data.id_token); // store에 새로 갱신한 access token 저장
            console.log('setIsMethodRecalling false');
            store.commit('setIsMethodRecalling', false); // isMethodRecalling을 false로 변경(새로운 token을 갱신 및 저장 중이지 않은 상태)
            setTimeout(() => {
              resolve('access token 갱신 및 저장 완료 -> method 재호출 1');
            }, 1000);
          })
          .catch((err1) => {
            console.log('BE에 access token 저장 실패');
            console.log(err1);
            console.log(err1.response);
            setTimeout(() => {
              reject(0); // BE에 access token 저장 실패
            }, 1);
          });
        })
        .catch((err) => {
          // refresh_token도 만료되어 사용자에게 재로그인 요청
          console.log("refresh token 만료(access token 갱신 실패)");
          console.log(err);
          console.log(err.response);
          setTimeout(() => {
            reject(1); // refresh token 만료(access token 갱신 실패)
          }, 1);
        });
      } else if (store.state.user_info.user_type === 'django' || store.state.user_info.user_type === 'django-prosecution') {
        http
        .get('account/update-token-recolumn/', getRefreshTokenConfig(store.state.refresh_token, store.state.auth_refresh_mode)) // 설정된 인증 모드로 새로운 access token 받아오기
        .then(res => {
          console.log('update-token-recolumn res', res)
          // store.commit('setRefreshToken', res.data.refresh_token); // store에 새로 갱신한 refresh token 저장
          if (res.data.access_token) { // access token이 있다면(null이 아니라면)
            store.commit('setAccessToken', res.data.access_token); // store에 새로 갱신한 access token 저장
          }
          console.log("setIsMethodRecalling false");
          store.commit('setIsMethodRecalling', false); // isMethodRecalling을 false로 변경(새로운 token을 갱신 및 저장 중이지 않은 상태)
          setTimeout(() => {
            resolve("access token 갱신 및 저장 완료 -> method 재호출 2");
          }, 1000);
        })
        .catch((err) => {
          // refresh_token도 만료되어 사용자에게 재로그인 요청
          console.log("refresh token 만료(access token 갱신 실패)");
          console.log(err);
          console.log(err.response);
          setTimeout(() => {
            reject(1); // refresh token 만료(access token 갱신 실패)
          }, 1);
        });
      }
    } else {
      // methodRecall이 호출되고 새로운 token을 갱신 및 저장 중인 상태라면
      setTimeout(() => {
        resolve("access token 갱신 및 저장 완료 -> method 재호출 3");
        console.log("setIsMethodRecalling false");
        store.commit('setIsMethodRecalling', false);
      }, 1000);
    }
  });
}

export default {
  // user_info 전체를 갱신하고 서버에 저장
  async updateUserInfo({ commit, dispatch }, payload) {
    console.log('updateUserInfo', payload)
    commit('SET_USER_INFO', payload)
    await dispatch('syncUserSortJsonToServer')
  },
  // sort_json 특정 값만 변경하고 서버에 저장 (가장 자주 쓸 것)
  async updateUserSortValue({ commit, dispatch }, { key, value }) {
    console.log('updateUserSortValue', { key, value })
    commit('SET_USER_SORT_VALUE', { key, value })
    await dispatch('syncUserSortJsonToServer')
  },
  // sort_json 저장
  async syncUserSortJsonToServer({ state, getters, commit }) {
    console.log('syncUserSortJsonToServer')
    // 토큰 없으면 로그아웃 + 이동
    if (!state.access_token) {
      console.log('토큰 없으면 로그아웃 + 이동')
      commit('logout')
      router.push('/').catch(() => {})
      return
    }

    const userId = state.user_info?.pk || state.user_info?.id
    if (!userId) {
      console.log('userId 없음')
      return
    }

    const body = { sort_json: state.user_info?.sort_json || {} }
    console.log('syncUserSortJsonToServer body', body)
    const makeHeaders = () => ({ Authorization: 'Bearer ' + state.access_token })

    try {
      await http.put(`account/user/${userId}/`, body, { headers: makeHeaders() })
    } catch (err) {
      if (err?.response?.status !== 401) throw err

      // access token 만료 → recall 후 재시도
      try {
        const msg = await methodRecall()
        console.log(msg)
        // methodRecall 내부에서 state.access_token 갱신된다고 가정(기존 로직 그대로)
        await http.put(`account/user/${userId}/`, body, { headers: makeHeaders() })
      } catch (err_msg) {
        if (err_msg === 0) {
          // BE에 access token 저장 실패
          console.log('BE에 access token 저장 실패')
          return
        }

        // refresh token 만료
        Swal.mixin({
          toast: true,
          showClass: { popup: 'animate__animated animate__fadeInDown' },
          hideClass: { popup: 'animate__animated animate__fadeOutUp' },
          position: 'top',
          showConfirmButton: false,
          showCloseButton: true,
          timer: getters.toastTimer,
          timerProgressBar: false,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        }).fire({
          icon: 'warning',
          iconColor: '#ffc107',
          title: "<div style='font-size: 16px; color: #0D0E17'>다시 로그인해 주세요.<div>",
          width: getters.toastWidth,
          background: getters.toastBgColor,
        })

        commit('logout')
        router.push('/').catch(() => {})
      }
    }
  },
}
